import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatTableDataSource, MatSort, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';

@Component({
  selector: 'app-supplier-invoice-report',
  templateUrl: './supplier-invoice-report.component.html',
  styleUrls: ['./supplier-invoice-report.component.css']
})
export class SupplierInvoiceReportComponent implements OnInit {

  supplier_info = [];
  supplier_name: string;
  supplier_no: string;
  mobile: string;

  private dp = [];

  displayedColumns = ['supplier_invoice_no', 'sub_item_number', 'sub_item_name', 'unit_name',
    'count', 'price', 'discount', 'tax_amount', 'total_price'];
  dataSource = new MatTableDataSource(this.dp);
  @ViewChild(MatSort) sort: MatSort;

  constructor(private utils: Utils, private applicationConstants: ApplicationConstants,
    private queryList: QueryList, private dialogRef: MatDialogRef<SupplierInvoiceReportComponent>,
    @Inject(MAT_DIALOG_DATA) public dialog_data: any) { }

  ngOnInit() {

    this.supplier_info = this.dialog_data;

    this.supplier_name = this.supplier_info['supplier_name'];
    this.supplier_no = this.supplier_info['supplier_no'];
    this.mobile = this.supplier_info['mobile'];

    let query = "SELECT `supplier_invoice_item`.* , `unit`.`unit_name` FROM `supplier_invoice_item` , " +
      "`unit`, `supplier_invoice` WHERE `supplier_invoice_item`.`status` = '1' AND `unit`.`unit_id` = " +
      "`supplier_invoice_item`.`unit_id` AND `supplier_invoice_item`.`supplier_invoice_no` = " +
      "`supplier_invoice`.`supplier_invoice_no` AND `supplier_invoice`.`supplier_no` = '" + this.supplier_no + "'";
    let obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.dp = data.data['list'];
        this.dataSource = new MatTableDataSource(this.dp);
        this.dataSource.sort = this.sort;
      });
  }

  cancel() {
    this.dialogRef.close(this.dialog_data);
  }

}
